import {
  type EmployeeQueries,
  defEmployeeQueries,
} from '@kizen/query/employee';
import AxiosService from '__services/AxiosService';

const queries: EmployeeQueries = defEmployeeQueries(AxiosService);

export const employeeCustomObjectConfigQuery: EmployeeQueries['employeeCustomObjectConfigQuery'] =
  queries.employeeCustomObjectConfigQuery;

export const employeePageConfigQuery: EmployeeQueries['employeePageConfigQuery'] =
  queries.employeePageConfigQuery;

export const employeeHistoryQuery: EmployeeQueries['employeeHistoryQuery'] =
  queries.employeeHistoryQuery;
